<template>
	<div class='withdraw'>
		<div class="top">
			<div class="tabList">
				<div
					class="item"
					@click="onTab(v,i)"
					:class="{active:i == tabI}"
					v-for="(v,i) in list"
					:key="v.name"
				>
					{{ v.name }}
				</div>
			</div>

			<div class="header">
				<div class="amount">
					可提现额度：{{amount || 0}}
				</div>

				<el-button
					@click="show = true"
					type="primary"
					size="small"
					round
				>去提现</el-button>
			</div>
		</div>

		<div class="content">
			<component :is="isName"> </component>
		</div>

		<!-- 提现 -->
		<el-dialog
			title="提现"
			width="25%"
			:visible.sync="show"
		>
			<div class="withdrawDialog">
				<div class="topbox">
					<div class="text">
						可提现金额（元）
					</div>
					<div class="amount">
						¥ {{ amount }}
					</div>
				</div>

				<div class="inp_box">
					<div class="span">￥</div>

					<div class="input">
						<input
							type="number"
							style="margin:0 35rpx 0 25rpx;height: 100%;"
							v-model="inp_amount"
						>
					</div>

					<div
						class="text"
						style="color: #326AFB;"
						@click="inp_amount = amount"
					>
						全部提现
					</div>
				</div>

				<div class="typeBox">
					<div
						class="item"
						:class="{typeI:typeI == i}"
						@click="typeI = i"
						v-for="(v,i) in typeList"
						:key="i"
					>
						<img
							:src="v.src"
							alt=""
						>

						<div class="name">
							{{ v.name }}
						</div>
					</div>
				</div>

				<div
					class="inputbox"
					v-if="typeI == 1"
				>
					<div class="demo-input-suffix">
						<div class="tetx">姓名</div>
						<el-input
							placeholder="请输入姓名"
							v-model="name"
						>
						</el-input>
					</div>
					<div class="demo-input-suffix">
						<div class="tetx">
							支付宝账号
						</div>
						<el-input
							placeholder="请输入支付宝账号"
							v-model="alipayAccount"
						>
						</el-input>
					</div>
				</div>

				<div class="btn">
					<el-button
						@click="withdrawCash"
						type="primary"
						round
					>申请提现</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import { selectOrderCashWithdraw, withdrawCash } from "@/api/professionServer";
import earnings from "./earnings";
import applyFor from "./applyFor";
export default {
  name: "withdraw",
  //import引入的组件需要注入到对象中才能使用
  components: {
    earnings,
    applyFor,
  },
  data() {
    //这里存放数据
    return {
      show: false,
      inp_amount: "",
      tabI: 0,
      isName: "earnings",
      list: [
        {
          name: "收益记录",
          isName: "earnings",
        },
        {
          name: "提现申请记录",
          isName: "applyFor",
        },
      ],
      typeI: 0,
      typeList: [
        {
          name: "微信",
          src:
            this.$store.state.onlineBasePath +
            "group1/M00/12/38/L2pUHWSeQDSAILDlAAAFr4J2LNM291.png",
        },
        {
          name: "支付宝",
          src:
            this.$store.state.onlineBasePath +
            "group1/M00/12/39/L2pUHWSeSqmAU7MHAAAGEENdlmQ092.png",
        },
      ],
      amount: 0,
      alipayAccount: "",
      name: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    onTab(v, i) {
      this.tabI = i;
      this.isName = v.isName;
    },

    // 申请提现
    async withdrawCash() {
      if (this.inp_amount > this.amount || !this.inp_amount) {
        this.$message("无法提现");
        return;
      }

      const data = {
        amount: this.inp_amount,
      };

      if (this.typeI == 1) {
        data.alipayAccount = this.alipayAccount;
        data.name = this.name;
      }
      const res = await withdrawCash(data);

      if (res.code != 200) {
        this.$message(res.data);
      } else {
        this.$message.success("申请提现成功");
        this.isName = "";

        setTimeout(() => {
          this.show = false;
          this.isName = "applyFor";
        }, 1200);
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  async created() {
    let res = await selectOrderCashWithdraw();
    if (res.code !== 200) return;
    this.amount = res.data.cashWithdrawAmount;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
.withdraw {
  height: 100%;
  overflow: auto;
  box-sizing: border-box;

  .top {
    display: flex;
    align-items: center;
    padding: 15px;
    height: 60px;
    box-sizing: border-box;
    border-bottom: 1px solid #eaeaea;
    justify-content: space-between;
    .tabList {
      display: flex;
      align-items: center;
      font-size: 15px;
      gap: 20px;
      .item {
        cursor: pointer;
        padding: 10px;
        border-radius: 5px;

        &:hover {
          background: #edf2ff;
          color: #326afb;
        }
      }

      .active {
        background: #edf2ff;
        color: #326afb;
      }
    }
    .header {
      display: flex;
      align-items: center;
      gap: 40px;
      .amount {
      }
    }
  }

  .content {
    height: calc(100% - 60px);
  }

  .withdrawDialog {
    .topbox {
      border: 0;
      display: flex;
      flex-direction: column;
      gap: 20px;
      padding: 20px 0;
      border-bottom: 1px solid #f0f0f0;
      .text {
      }

      .amount {
        font-size: 25px;
      }
    }
    .inp_box {
      margin: 20px 0;
      display: flex;
      align-items: center;
      gap: 20px;
      justify-content: space-between;
      .span {
        font-size: 32px;
      }
      .input {
        flex: 1;
        height: 60px;
        border-bottom: 1px solid #f0f0f0;

        input {
          width: 100%;
          font-size: 32px;
          height: 100%;
        }
      }
      .text {
        cursor: pointer;
        width: 80px;
        font-size: 16px;
        text-align: center;
      }
    }
    .typeBox {
      display: flex;
      align-items: center;
      gap: 20px;
      .item {
        cursor: pointer;
        padding: 10px 0;
        flex: 1;
        border: 1px solid #f0f0f0;
        display: flex;
        justify-content: center;
        gap: 20px;
        border-radius: 10px;
        align-items: center;
        img {
          width: 40px;
        }
        .name {
        }

        &:hover {
          border: 1px solid #326afb;
        }
      }

      .typeI {
        border: 1px solid #326afb;
      }
    }

    .inputbox {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      gap: 20px;
      .demo-input-suffix {
        display: flex;
        flex-direction: column;
        gap: 20px;
      }
    }

    .btn {
      margin: 40px 0 0;
      display: flex;
      align-items: center;
      justify-content: center;

      .el-button {
        width: 45%;
        height: 50px;
        font-weight: bold;
        font-size: 18px;
      }
    }
  }
}
</style>